import { TaskProgressProps, TaskCategoryProgress } from "@/interfaces/progress_types";
import { ProjectProgressBar } from "./ProgressBarContainer";

export type SegmentedProgressBarProps = {
    taskProgress: TaskProgressProps
    electricalProgress: TaskCategoryProgress
    mechanicalProgress: TaskCategoryProgress
    plumbingProgress: TaskCategoryProgress
    otherProgress: TaskCategoryProgress
}

export function SegmentedProgressBar({ taskProgress, electricalProgress, mechanicalProgress, plumbingProgress, otherProgress }: SegmentedProgressBarProps) {
    // Calculate the weighted width of each segment based on its proportion of total tasks
    const totalTasks = taskProgress.tasks_total || 1; // Prevent division by zero


    // Calculate segment widths as percentages of the total bar
    const electricalWidth = (electricalProgress.tasks_total / totalTasks) * 100;
    const mechanicalWidth = (mechanicalProgress.tasks_total / totalTasks) * 100;
    const plumbingWidth = (plumbingProgress.tasks_total / totalTasks) * 100;
    const otherWidth = (otherProgress.tasks_total / totalTasks) * 100;

    return (
        <div className="w-full space-y-4">
            <div className="w-full h-4 bg-stone-200 dark:bg-stone-800 rounded-lg overflow-hidden flex">
                {electricalProgress.tasks_total > 0 && (
                    <ProjectProgressBar
                        width={electricalWidth}
                        color="yellow"
                        category="Electrical"
                        category_progress={electricalProgress} />
                )}

                {mechanicalProgress.tasks_total > 0 && (
                    <ProjectProgressBar
                        width={mechanicalWidth}
                        color="green"
                        category="Mechanical"
                        category_progress={mechanicalProgress} />
                )}

                {plumbingProgress.tasks_total > 0 && (
                    <ProjectProgressBar
                        width={plumbingWidth}
                        color="blue"
                        category="Plumbing"
                        category_progress={plumbingProgress} />
                )}

                {otherProgress.tasks_total > 0 && (
                    <ProjectProgressBar
                        width={otherWidth}
                        color="purple"
                        category="Other"
                        category_progress={otherProgress} />
                )}
            </div>
        </div>
    );
}
